import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DeleteBrandBrief($id: ID!) {
    deleteBrandBrief(id: $id) {
      id
    }
  }
`;

export const deleteBrandBrief = (id) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { id },
  }).then(({ data }) => getSingleProp(data));
